import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5f0fc12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api__pricing" }
const _hoisted_2 = { class: "api__pricing--text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "m-bottom-40" }, "API Pricing", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The costs are calculated on a mix of inputs or matches depending on the process for updating addresses/identity, forward or reverse appending. Full access to the API using your key requires our Premium user plan and you are billed the minimum with additional usage billed at the end of the month, if over the minimum. You can upgrade your plan by clicking on the “start now” button at the top of the webpage. If you have a question we would love to talk and can customize most processes in 5 business days depending on your needs. ", -1))
const _hoisted_5 = {
  key: 0,
  class: "m-top-10"
}
const _hoisted_6 = { class: "api__pricing-table m-left-40" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "api__pricing-table--header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Pricing table")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "api__pricing-table--body"
}
const _hoisted_9 = { class: "m-right-10" }
const _hoisted_10 = { class: "w-s-nw" }
const _hoisted_11 = {
  key: 1,
  class: "api__pricing-table--loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.apiPricing && !_ctx.loader)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.definitions, (str, id) => {
              return (_openBlock(), _createElementBlock("li", { key: id }, [
                _createElementVNode("span", null, _toDisplayString(str), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_ctx.apiPricing && !_ctx.loader)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.apiPricing), (api, id) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "api__pricing-table--tr",
                key: id
              }, [
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.PRICING_API_TITLE[api]), 1)
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.getPrice(api)), 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11))
    ])
  ]))
}